// extracted by mini-css-extract-plugin
export default {"container":"Header_container__BfEV9","main":"Header_main__QxClZ","list":"Header_list__uJOIc","link":"Header_link__wwjA7","name":"Header_name__7M7Qh"};